<template>
    <div class="center-page">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="待确定" name="1"></el-tab-pane>
            <el-tab-pane label="待支付" name="2"></el-tab-pane>
            <el-tab-pane label="待完成" name="3"></el-tab-pane>
            <el-tab-pane label="已完成" name="4"></el-tab-pane>
            <el-tab-pane label="已取消" name="-1"></el-tab-pane>
        </el-tabs>
        <div class="mt-20" v-loading="loading">
            <OrderHouseLandlord @refreshOrder="landlordOrder"
                                @feedback="feedback(item)"
                                @evaluate="evaluate(item)"
                                v-for="(item,index) in list"
                                :item="item" :key="index"></OrderHouseLandlord>
            <el-alert v-if="list.length<=0" title="暂无相关订单~" center :closable="false" type="warning" show-icon></el-alert>
        </div>
        <el-dialog title="房东反馈" :visible.sync="showFeedback" width="500px">
            <el-form label-position="right" label-width="120px">
                <el-form-item label="反馈问题：">
                    <el-input placeholder="请输入反馈问题" v-model="feedbackForm.title"></el-input>
                </el-form-item>
                <el-form-item label="反馈内容：">
                    <el-input type="textarea"
                              v-model="feedbackForm.content"
                              placeholder="请输入反馈内容"
                              :autosize="{ minRows: 8, maxRows: 16}"
                              maxlength="2500" show-word-limit></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="floading" @click="landlordOrderComplain">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="评价" :visible.sync="showEvaluate" width="500px">
            <el-form label-position="right" label-width="120px">
                <el-form-item label="用户名称：">
                    {{currentItem.user_name}}
                </el-form-item>
                <el-form-item label="评价TA：">
                    <el-rate class="mt-10" v-model="evaluateForm.star" show-score></el-rate>
                </el-form-item>
                <el-form-item label="评价留言：">
                    <el-input type="textarea"
                              v-model="evaluateForm.assess"
                              placeholder="请输入反馈内容"
                              :autosize="{ minRows: 8, maxRows: 16}"
                              maxlength="2500" show-word-limit></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="eloading" @click="landlordUserEvaluation">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import OrderHouseLandlord from "../../components/OrderHouseLandlord";
    export default {
        name: "landlordOrder",
        components:{OrderHouseLandlord},
        data() {
            return {
                loading: false,
                floading:false,
                eloading:false,
                showFeedback: false,
                showEvaluate: false,
                activeName: '1',
                list: [],
                currentId: '',
                currentItem: '',
                feedbackForm:{
                    title: '',
                    content: ''
                },
                evaluateForm:{
                    star: 5,
                    assess: '',
                    type: 9
                }
            }
        },
        created() {
            this.landlordOrder()
        },
        methods: {
            handleClick() {
                this.landlordOrder()
            },
            async landlordOrder(){
                this.loading = true;
                let [e, data] = await this.$api.landlordOrderApi({order_state: this.activeName})
                this.loading = false;
                this.list = data.result.ordera;
            },
            feedback(item){
                this.currentId = item.id;
                this.showFeedback = true;
            },
            evaluate(item){
                this.currentItem = item;
                this.showEvaluate = true;
            },
            async landlordOrderComplain(){
                this.floading = true;
                let [e, data] = await this.$api.landlordOrderComplainApi({order_id: this.currentId, ...this.feedbackForm})
                this.floading = false;
                if(e) return this.$message.warning(e.data.error);
                if(data.status){
                    this.showFeedback = false;
                    this.$message.success('提交成功')
                }
            },
            async landlordUserEvaluation(){
                this.eloading = true;
                let [e, data] = await this.$api.landlordUserEvaluationApi({
                    shop_id: this.currentItem.user_id,
                    order_id: this.currentItem.id,
                    ...this.evaluateForm
                })
                this.eloading = false;
                if(data.status){
                    this.showEvaluate = false;
                    this.$message.success('提交成功')
                }
            }
        },
    }
</script>

<style scoped>

</style>
